import { MINERVA_API_URL, EDGE_RANKING_API_URL } from '@/config';
import { http, removeCountryCode, setCountryCode } from '@/plugins/http';
import * as types from './mutation-types';

export function setCatQuizWrongResults({ commit }, catQuizWrongResults) {
  commit(types.SET_QUIZ_WRONG_RESULTS, catQuizWrongResults);
}

export function resetCatQuizWrongResults({ commit }) {
  commit(types.RESET_QUIZ_WRONG_RESULTS);
}

export function fetchProficiencyHistory({ dispatch }, { domainId, filters }) {
  return http.get(`${MINERVA_API_URL}/users/cl-proficiency-history?domain_id=${domainId}`, { params: filters })
    .then(resp => (
      dispatch('setProficiencyHistory', resp.data)
    ));
}

export function setProficiencyHistory({ commit }, proficiencyHistory) {
  commit(types.SET_PROFICIENCY_HISTORY, proficiencyHistory);

  return Promise.resolve(proficiencyHistory);
}

export function setDomainElements({ commit }, domainsElements) {
  commit(types.SET_DOMAINS_ELEMENTS, domainsElements);

  return Promise.resolve(domainsElements);
}

export function creatCatCard(_, { domainId, quizCount }) {
  return http.post(`${MINERVA_API_URL}/cats/`, {
    quiz_count: quizCount,
    domain_id: domainId,
  })
    .catch(err => Promise.reject(err.response));
}

export function fetchQuizResultCaches({ commit }, params) {
  return http.get(`${MINERVA_API_URL}/quiz_result_caches`, { params })
    .then(res => (commit(types.SET_QUIZ_RESULT_CACHES, res.data)))
    .catch(err => Promise.reject(err.response));
}

export function fetchCatList({ commit }, params) {
  return http.get(`${MINERVA_API_URL}/cats`, { params })
    .then(res => (commit(types.SET_CAT_LIST, res.data)))
    .catch(err => Promise.reject(err.response));
}

export function fetchRankingScores({ rootState, commit }, params) {
  removeCountryCode();
  return http.get(`${EDGE_RANKING_API_URL}/scores`, { params })
    .then(res => (commit(types.SET_RANKING_SCORES, res.data)))
    .catch(err => Promise.reject(err))
    .finally(() => setCountryCode(rootState.Auth.user.country_code));
}

export function fetchUserRanking({ rootState, commit }, params) {
  removeCountryCode();
  return http.get(`${EDGE_RANKING_API_URL}/users/me`, { params })
    .then(res => (commit(types.SET_USER_RANKING, res.data)))
    .catch(err => Promise.reject(err.response))
    .finally(() => setCountryCode(rootState.Auth.user.country_code));
}

export function fetchCatExpHistories({ commit }, params) {
  return http.get(`${MINERVA_API_URL}/cat_exp_histories`, { params })
    .then(res => (commit(types.SET_CAT_EXP_HISTORIES, res.data)))
    .catch(err => Promise.reject(err.response));
}

export function fetchFlightBoxRewardHistories({ commit }, params) {
  return http.get(`${MINERVA_API_URL}/flight_box_reward_histories`, { params })
    .then(res => (commit(types.SET_FLIGHT_BOX_REWARD_HISTORIES, res.data)))
    .catch(err => Promise.reject(err.response));
}
